module.exports = __webpack_public_path__ + "static/journey-top-sm-11249291b6c7a89c5975e84451d596b0.png";